import React from 'react';
import classnames from 'classnames';
import { BadgeCounterProps } from './badge-counter.types';
import { useStyles } from './badge-counter.styles';

export const BadgeCounter: React.FC<BadgeCounterProps> = (props): JSX.Element => {
  const { highlightUserStar } = useStyles();
  return <div className={highlightUserStar}>{props.additionalUsersCount}</div>;
};
